import instantCoffeeImg from "../assets/images/products/coverpage/Instant Coffee.png";
import groundCoffeeImg from "../assets/images/products/coverpage/Ground Coffee.png";
import kaapiCoverImg from "../assets/images/products/kaapi-1.jpg";
import coffeeBeansImg from "../assets/images/products/coverpage/Coffee Beans Cover Pic.png";
import coffeeGearImg from "../assets/images/products/coverpage/Coffee Gear 2.jpg";
import flavouredCoffeeImg from "../assets/images/products/coverpage/Flavoured coffee.png";
import arabicaBeansCoverImg from "../assets/images/products/ARABICA.jpg";
import robustaCoverImg from "../assets/images/products/Robusta-1.jpg";
import arabicaCoffeeBeansCoverImg from "../assets/images/products/Arabica-Coffee-Beans-2.jpg";
import coffeeWarmerImg from "../assets/images/products/coffee-warmer.png";
import stovetopEspressoImg from "../assets/images/products/Stovetop-Espresso-Maker.png";
import traditionalFilterImg from "../assets/images/products/Traditional-coffee-filter.png";
import coffeeMugImg from "../assets/images/products/coffee-Mug.jpg";
import joltCoverImg from "../assets/images/products/jolt-65-1.jpg";
import vintageCoverImg from "../assets/images/products/vintage45g-1.jpg";
import hazelnutCoverImg from "../assets/images/products/Hazelnut-Heritage-2.jpg";
import vanillaCoverImg from "../assets/images/products/Vanilla-Euphoria-1.jpg";
import caramelCoverImg from "../assets/images/products/Caramel-Epoque-2.jpg";
import discoveryCoverImg from "../assets/images/products/Coffee-Gable-Coffee-Discovery-1.jpg";

export const MAIN_CATEGORIES = [
  {
    id: 1,
    categoryName: "Instant Coffee",
    image: instantCoffeeImg,
    comingSoon: false,
  },
  {
    id: 2,
    categoryName: "Ground Coffee",
    image: groundCoffeeImg,
    comingSoon: false,
  },
  {
    id: 3,
    categoryName: "Coffee Beans",
    image: coffeeBeansImg,
    comingSoon: false,
  },
  {
    id: 4,
    categoryName: "Coffee Gear",
    image: coffeeGearImg,
    comingSoon: false,
  },
  {
    id: 5,
    categoryName: "Flavoured Instant Coffee",
    image: flavouredCoffeeImg,
    comingSoon: false,
  },
];

const SUB_CATEGORIES_BY_PARENT = {
  1: [
    {
      id: 101,
      categoryName: "Vintage",
      image: vintageCoverImg,
      comingSoon: false,
    },
    {
      id: 102,
      categoryName: "Jolt",
      image: joltCoverImg,
      comingSoon: false,
    },
  ],
  2: [
    {
      id: 201,
      categoryName: "KAAPI",
      image: kaapiCoverImg,
      comingSoon: false,
    },
  ],
  3: [
    {
      id: 301,
      categoryName: "Arabica Beans",
      image: arabicaBeansCoverImg,
      comingSoon: false,
    },
    {
      id: 302,
      categoryName: "Robusta Beans",
      image: robustaCoverImg,
      comingSoon: false,
    },
    {
      id: 303,
      categoryName: "Arabica Coffee Beans",
      image: arabicaCoffeeBeansCoverImg,
      comingSoon: false,
    },
  ],
  4: [
    {
      id: 401,
      categoryName: "Traditional South Indian Coffee Filter",
      image: traditionalFilterImg,
      comingSoon: false,
    },
    {
      id: 402,
      categoryName: "Stovetop Espresso Maker",
      image: stovetopEspressoImg,
      comingSoon: false,
    },
    {
      id: 403,
      categoryName: "Coffee Warmer",
      image: coffeeWarmerImg,
      comingSoon: false,
    },
    {
      id: 404,
      categoryName: "Coffee Mug",
      image: coffeeMugImg,
      comingSoon: false,
    },
  ],
  5: [
    {
      id: 501,
      categoryName: "Hazelnut Heritage",
      image: hazelnutCoverImg,
      comingSoon: false,
    },
    {
      id: 502,
      categoryName: "Vanilla Euphoria",
      image: vanillaCoverImg,
      comingSoon: false,
    },
    {
      id: 503,
      categoryName: "Caramel Époque",
      image: caramelCoverImg,
      comingSoon: false,
    },
    {
      id: 504,
      categoryName: "Coffee Gable Coffee Discovery Set",
      image: discoveryCoverImg,
      comingSoon: false,
    },
  ],
};

export function getSubCategories(parentId) {
  return SUB_CATEGORIES_BY_PARENT[parentId] || [];
}
